import {
  adobeActiveApps,
  adobeUrls,
  geberatePageLoadDl,
  generateErrorEventDl,
  generateLinkClickDl,
} from "../config/adobe.config";
import { generateAppid } from "./useAppids";

const useDatalayer = () => {
  const pushHandler = (eventObject) => {
    const { appid } = generateAppid();
    const isActiveByAppAndEnv =
      adobeActiveApps[appid]?.[process.env.REACT_APP_NODE_ENV];
    const killSwitch = process.env.REACT_APP_DATA_LAYER === "enabled"; // global switch

    // killSwitch: Switch to toggle datalayer between regions. Will be applicable for all appid id's.
    // isActiveByAppAndEnv: feature will be turned on and off according to appid and environment
    if (!killSwitch || !isActiveByAppAndEnv) return;

    const analyticLayer = window.adobeDataLayer;
    if (!analyticLayer) window.adobeDataLayer = [];

    console.log("datalayer event:", eventObject.event);

    window.adobeDataLayer.push(eventObject);
  };

  const addAdobeScript = () => {
    const { appid } = generateAppid();
    const isActiveByAppAndEnv =
      adobeActiveApps[appid]?.[process.env.REACT_APP_NODE_ENV];
    const killSwitch = process.env.REACT_APP_DATA_LAYER === "enabled"; // global switch
    if (isActiveByAppAndEnv && killSwitch) {
      console.log("Loading Datalayer Script...");
      const dlScript = document.createElement("script");
      dlScript.src = adobeUrls[appid];
      dlScript.async = true;
      window.document.head.appendChild(dlScript);
    }
  };

  // 'siteSection': 'login', // hardcode the section of the website
  const pageLoadsDL = (subPage, flow) => {
    const data = geberatePageLoadDl(subPage, flow);
    pushHandler(data);
  };

  // 'errorType':  <errorType>, // Capture 'source:type' E.g  'API:Akamai Failure', UX: Invalid Selections, userError:three-failed-attempts, wrong-password/user name
  // 'errorCode': <errorCode>,   // Error code in the backend / transaction systems E.g 502, 404, 500
  // 'errorCategory': <errorCategory>, 'login-in-error'
  // 'errorDescription': <errorDescription>, //Actual Error Text

  const onError = ({ errorType, errorCode, errorDescription }) => {
    const data = generateErrorEventDl(errorType, errorCode, errorDescription);
    pushHandler(data);
  };

  const onClickLink = (linkName, linkHref) => {
    const data = generateLinkClickDl(linkName, linkHref);
    pushHandler(data);
  };

  return {
    addAdobeScript,
    pageLoadsDL,
    onError,
    onClickLink,
  };
};

export default useDatalayer;
